import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
let positionSwiperWr = document.querySelectorAll('.position-sec-swiper-wr');
positionSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 12,
      slidesPerView: 2,
      loop: slidesCount >= 3,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        375: {
          slidesPerView: 2,
        },
        440: {
          slidesPerView: 2.5,
        },
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          spaceBetween: 26,
          slidesPerView: 3.5,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });


    swiperObserver(swiper);
  }
});

let secondPositionSwiperWr = document.querySelectorAll('.position-sec-swiper-last-wr');
secondPositionSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 12,
      slidesPerView: 2,
      initialSlide: 0,
      loop: slidesCount >= 3,
      loopedSlides: slidesCount,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        375: {
          slidesPerView: 2,
        },
        440: {
          slidesPerView: 2.5,
        },
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          spaceBetween: 26,
          slidesPerView: 3.5,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },

    });

    swiperObserver(swiper);
  }
});